import './evidence-file.scss';
import UploadIcon from "../../../../../assets/icons/UI/icons/upload.svg";
import React, {useRef, useState} from "react";
import OpenBodyIcon from '../../../../../assets/icons/UI/select/arrow-down.svg';
import CloseBodyIcon from '../../../../../assets/icons/UI/select/arrow-up.svg';
import LabelKMQ from "../../../../../components/UI/Label/LabelKMQ";
import ButtonKMQ from "../../../../../components/UI/Button/ButtonKMQ";
import {ButtonTypes} from "../../../../../constants/ui/types/ButtonTypes";

interface EvidenceProps {
  onFileUploaded: (file: File) => void;
  file: File | undefined;
  title: string | undefined;
  additionalNote: string;
  onSubmit: () => void
}

const EvidenceFile = (props: EvidenceProps) => {
  const {
    onFileUploaded,
    file,
    title,
    additionalNote,
    onSubmit
  } = props;

  const [requestIsOpen, setRequestIsOpen] = useState<boolean>(true);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files[0]) {
      onFileUploaded(files[0]);
    }
  };

  const onDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const newFile = event.dataTransfer.files[0];
    if (newFile) {
      onFileUploaded(newFile);
    }
  };

  const handleBrowseClick = () => {
    inputRef.current?.click();
  };

  const handleSubmit = () => {
    setSubmitted(true);
    onSubmit();
  }

  const renderTitle = () =>
    <div className={'evidence-file-title'}>
      <span className={'evidence-file-title-text'}>
        {title}
      </span>
      <div className={'evidence-file-title-line'}/>
      <img
        src={requestIsOpen ? CloseBodyIcon : OpenBodyIcon}
        alt={requestIsOpen ? 'close file request' : 'open file request'}
        className={'evidence-file-title-arrow'}
        onClick={() => setRequestIsOpen(!requestIsOpen)}
      />
    </div>


  return <div className={'evidence-file'}>
    {renderTitle()}

    {requestIsOpen
      ? <div className={'evidence-file-body'}>
        <div className={'evidence-file-body-note'}>
          <span className={'evidence-file-body-note-bold'}>
            {'Notes to applicant: '}
          </span>
          {additionalNote}
        </div>
        <LabelKMQ>
          Upload Attachment
        </LabelKMQ>
          <div className={'profile-file-upload-container'}
               onDrop={onDrop}
               onDragOver={(event) => event.preventDefault()}
        >
          <div className={'profile-file-upload-container-image'}
               onClick={handleBrowseClick}
          >
            <img
              src={UploadIcon}
              alt={'upload'}
            />
            <input
              type="file"
              onChange={onInputChange}
              ref={inputRef}
              accept=".doc,.docx,.pdf,.mp4,.mov,.png,.jpeg,.jpg"
            />
          </div>
          <div className={'profile-file-upload-container-description'}>
            <div className={'profile-file-upload-container-description-title'}>
              {submitted ? 'Submitted!' : file?.name ? 'Submit your file' : 'Drag your file here'}
            </div>
            <div
              className={`profile-file-upload-container-description-text`}>
              {
                file
                  ? <span>
                    {file?.name}
                  </span>
                  :
                  <span>
                    Accepted file formats: .docx, .doc, .pdf, .jpg, .png, .mp4, .mov
                    <br/>
                    Max files size: 50MBs | Max files: 1
                  </span>
              }

            </div>
          </div>
          <div className={`profile-file-upload-container-divider`}>
            <div className={'profile-file-upload-container-divider-line'}/>
            <div className={'profile-file-upload-container-divider-text'}>
              OR
            </div>
            <div className={'profile-file-upload-container-divider-line'}/>
          </div>
          <div className={`profile-file-upload-container-browse`}>
          <span className={'profile-file-upload-container-browse-link'} onClick={handleBrowseClick}>
            Browse
          </span>
            {' your computer'}
          </div>
        </div>

        <div className={'evidence-file-body-submit'}>
          <ButtonKMQ disabled={!file?.name || submitted} onClick={handleSubmit} type={ButtonTypes.Tertiary}>
            Submit
          </ButtonKMQ>
        </div>
      </div>
      : null
    }
  </div>
}

export default EvidenceFile;